import moment from 'moment';
import T from 'i18n-react';
import React from 'react';
import PropTypes from 'prop-types';
import { withCurrentUser } from 'modules/auth/containers';
import { MainLayout } from '../components';
// import translations from '../../../locales';
import { Spinner } from 'modules/common/components';
import APIManager from 'modules/common/apiManager';
import { localStore } from 'helpers';
import { withRouter } from 'react-router';

moment.defineLocale('mn', {
  relativeTime: {
    future: '%s дараа',
    past: '%s өмнө',
    s: 'саяхан',
    m: 'минутын',
    mm: '%d минутын',
    h: '1 цагийн',
    hh: '%d цагийн',
    d: '1 өдрийн',
    dd: '%d өдрийн',
    M: '1 сарын',
    MM: '%d сарын',
    y: '1 жилийн',
    yy: '%d жилийн',
  },
});

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ',
    s: 's',
    m: 'm',
    mm: '%d m',
    h: 'h',
    hh: '%d h',
    d: 'd',
    dd: '%d d',
    M: 'a mth',
    MM: '%d mths',
    y: 'y',
    yy: '%d y',
  },
});

class TranslationWrapper extends React.Component {
  getChildContext() {
    return {
      __: (msg) => T.translate(msg),
      theme: 'tcc',
    };
  }

  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

TranslationWrapper.propTypes = {
  children: PropTypes.object,
};

TranslationWrapper.childContextTypes = {
  __: PropTypes.func,
  theme: PropTypes.string,
};

class MainLayoutContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLanguage: 'en',
      // loading: props.currentUser ? true : false
      loading: false,
    };
    this.currentUser = props.currentUser;
    this.mAPI = new APIManager();
    this.changeLanguage = this.changeLanguage.bind(this);
  }

  getChildContext() {
    return {
      changeLanguage: this.changeLanguage,
      currentLanguage: this.state.currentLanguage,
    };
  }

  componentDidMount() {
    this.changeLanguage(localStorage.getItem('currentLanguage'));
  }

  changeLanguage(languageCode) {
    const currentLanguage = languageCode || 'en';

    localStorage.setItem('currentLanguage', currentLanguage);

    moment.locale(currentLanguage);

    // T.setTexts(translations[currentLanguage]);

    this.setState({ currentLanguage });
  }

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }

    return (
      <TranslationWrapper>
        <MainLayout {...this.props} />
      </TranslationWrapper>
    );
  }
}

MainLayoutContainer.childContextTypes = {
  changeLanguage: PropTypes.func,
  currentLanguage: PropTypes.string,
};

export default MainLayoutContainer;



// WEBPACK FOOTER //
// src/modules/layout/containers/MainLayout.js